export default {
    SAVE_USER: "saveUser",
    SAVE_TOKEN: "saveToken",
    DELETE_STORE: "deleteStore",
    UPDATE_TOKEN: "updateToken",
    UPDATE_USER: "updateUser",
    CHANGE_LANGUAGE: "changeLanguage",
    ADD_EVENTS: "addEvents",
    DELETE_EVENT: "deleteEvent",
    IS_SYNCHRONIZING: "isSynchronizing",
    SAVE_SITES: "saveSites",
    CHANGE_SITE_SELECTED: "changeSiteSelected",
    CHANGE_SILO_SELECTED: "changeSiloSelected",
    CHANGE_VIEW_DETAILS: "changeViewDetails",
}